module.exports = __webpack_public_path__ + "img/logo.ca539c50.png";